import { clientCaseFactFindPartnerPrintApi } from './print';

export function clientCaseFactFindPartnerApi(path: string) {
  return {
    path,
    print: () => clientCaseFactFindPartnerPrintApi(`${path}/print`),
  };
}
